<div class="row justify-content-center" *ngIf="cameraError">
  <div class="col-auto">
    <br>
    <p>Error! Cannot access a camera</p>
  </div>
</div>

<div class="row justify-content-center" *ngIf="showCamera">
  <div class="col-auto">
    <webcam
      [videoOptions]="videoOptions"
      [captureImageData]="true"
      [trigger]="triggerObservable"
      (imageCapture)="handleImage($event)"
      [allowCameraSwitch]="true"
      (initError)="handleInitError($event)">
    </webcam>
  </div>
</div>

<div class="row justify-content-center" *ngIf="showCamera">
  <div class="col-auto text-center">
    <button class="btn btn-primary" type="button" (click)="triggerSnapshot()">Take picture</button>
  </div>
</div>

<hr *ngIf="webcamImages.length > 0">
<div class="row justify-content-center" *ngIf="webcamImages.length > 0">
  <div class="col-2 mb-3" *ngFor="let image of webcamImages">
    <div class="gallery-image">
      <img class="img-fluid" [src]="image.imageAsDataUrl" alt="">
      <i class="remove-image fa fa-3x fa-times" (click)="removeWebcamImage(image)"></i>
    </div>
  </div>
</div>

<hr *ngIf="images?.length > 0">
<div class="row justify-content-center" *ngIf="images?.length > 0">
  <div class="col-2 mb-3" *ngFor="let image of images">
    <div class="gallery-image">
      <img class="img-fluid" [src]="image.url" (click)="showImage(image.url)">
    </div>
  </div>
</div>

<div class="row justify-content-center mt-3">
  <div class="col-auto">
    <button class="btn btn-info" type="button" (click)="confirmTraceRequest()">
      Create Trace Request
    </button>
  </div>
</div>
